import script from "./SiteLogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteLogin.vue?vue&type=script&lang=ts&setup=true"

import "./SiteLogin.vue?vue&type=style&index=0&id=0ea1261e&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea1261e"]])

export default __exports__